import { getInitData } from '@/utils/getInitData';
import { settings } from '@/api/config';
import axios from 'axios';

export const activateVoucher = async (voucher: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/vouchers/activate?initData=${encodedInitData}`,
      {
        code: voucher,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};

export const checkCondition = async (
  voucher_id: number | undefined,
  condition_id: number | undefined,
) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/vouchers/${voucher_id}/conditions/${condition_id}/check?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};

export const getVoucherHistory = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/vouchers/history/redemptions?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};
